import { render } from "./T86.vue?vue&type=template&id=0ec23ee8&ts=true"
import script from "./T86.vue?vue&type=script&lang=ts"
export * from "./T86.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__